/* eslint-disable react/no-unescaped-entities */
import {Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Link} from '@chakra-ui/react';
import {RegisteredComponent} from '@builder.io/sdk-react';
import {ReactNode} from 'react';

const content: { question: string; answer: ReactNode }[] = [
  {
    question: 'Are your giveaways real?',
    answer: <>
      Absolutely! We're committed to genuine giveaways with real, exciting prizes. Check out the winners on our website,
      in our newsletter, and across our social media channels for proof of the joy we spread!
      {' '}
      <Link href="https://www.fanathem.com/winners/">https://www.fanathem.com/winners/</Link>
    </>,
  }, {
    question: 'How do you support YouTubers and content creators?',
    answer: <>
      We partner with YouTubers and creators, offering them half of our giveaway profits. This financial support helps
      them continue producing the content that everyone loves, making our giveaways a win-win for the community.
      {' '}
      <Link
        href="https://www.youtube.com/watch?v=EMyI2uZsIVY&t=6s">https://www.youtube.com/watch?v=EMyI2uZsIVY&t=6s</Link>
    </>
  }, {
    question: 'Do you sell customer information?',
    answer: <>
      No, your privacy is our top priority. We never sell, trade, or share your personal data. Your participation is
      secure and confidential with us.
    </>
  }, {
    question: 'How can I verify the authenticity of a giveaway?',
    answer: <>
      Our winners are always announced publicly—on our website, newsletters, and social media. We aim for transparency,
      making it easy for you to verify our giveaways' authenticity.
      {' '}
      <Link href="https://www.fanathem.com/winners/">https://www.fanathem.com/winners/</Link>
    </>
  }, {
    question: 'How do you select the random winners?',
    answer: <>
      Our winners are chosen with utmost fairness and integrity, which is why we entrust this crucial process to a
      third-party organizer renowned for their 70 years of experience in managing sweepstakes. This seasoned expert
      ensures every selection is random and impartial, upholding the highest standards of transparency. At
      Fanathem, we stake our reputation on their proven track record, ensuring every giveaway winner is
      selected with absolute fairness.
    </>
  }, {
    question: 'What is your return policy?',
    answer: <>
      Your satisfaction is crucial to us, especially when you support our giveaways by purchasing merchandise. If
      there’s ever an issue with your order, please contact us immediately via email or text. Whether it's a concern
      about the item's quality or a mistake in the order, we're committed to making it right. Depending on the issue,
      we offer replacements or refunds to ensure your complete satisfaction. Remember, customer service is our top
      priority. While you can't text Amazon about an order, you can certainly text us at Fanathem! We're
      here to support you every step of the way.
    </>
  }, {
    question: 'How do you ship the merchandise?',
    answer: <>
      Merchandise is shipped directly from our warehouse and will arrive in about a week. We use reputable courier
      services to ensure safe and timely delivery, providing tracking information for your convenience.
    </>
  }, {
    question: 'Which payment methods do you accept?',
    answer: <>
      For any purchases or support, we accept a wide range of payment methods, including major credit cards (Visa,
      MasterCard, American Express), and PayPal. Our payment process is secure, ensuring your details are protected.
    </>
  }, {
    question: 'Are you really a small business owned and operated by a veteran?',
    answer: <>
      Yes, we are a PROUD veteran-owned small business! At Fanathem, we not only print and ship our
      collectibles from right here in the good ol' U.S. of A, but we also hold a deep commitment to supporting fellow
      small business owners, entrepreneurs, and creators. Our mission is to empower them in their quest to build and
      live the American Dream for themselves and their families. Our journey is rooted in the values of service,
      community, and quality, ensuring that every part of our operation contributes positively to the dreams of
      Americans across the nation.
      {' '}
      <Link href="https://www.fanathem.com/about-us">https://www.fanathem.com/about-us</Link>
    </>
  }, {
    question: 'How can I learn more about testimonials from past winners?',
    answer: <>
      To dive into the exciting experiences of our past winners, we warmly invite you to visit our website and explore
      the testimonials section. Additionally, many of our winners share their joyful moments and feedback on our social
      media platforms. These testimonials offer a glimpse into the genuine excitement and satisfaction that comes with
      winning at Fanathem. It's not just about the prizes; it's about the positive impact and the memorable
      experiences we create for our community. So, go ahead and check out these stories to see the real difference
      we're making!
      {' '}
      <Link href="https://www.fanathem.com/winners/">https://www.fanathem.com/winners</Link>
    </>
  }
]

const GetwAccordion = () => {
  return (
    <Accordion>
      {content.map(item => (
        <AccordionItem key={item.question}>
          <h2>
            <AccordionButton>
              <Box as='span' flex='1' textAlign='left'>
                {item.question}
              </Box>
              <AccordionIcon/>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            {item.answer}
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

const component: RegisteredComponent = {
  component: GetwAccordion,
  name: 'GETW Accordion',
}

export default component;
